import React, { useState } from 'react';
import './TagCloud.css';

const MAX_VISIBLE = 15;

function TagCloud({ tags, activeTags, onToggle, onClear }) {
  const [expanded, setExpanded] = useState(false);

  if (!tags || tags.length === 0) return null;

  const visible = expanded ? tags : tags.slice(0, MAX_VISIBLE);
  const hasMore = tags.length > MAX_VISIBLE;

  return (
    <div className="tag-cloud">
      <div className="tag-cloud-header">
        <span className="tag-cloud-title">
          Tags filtern
          {activeTags.length > 0 && (
            <span className="tag-cloud-badge">{activeTags.length}</span>
          )}
        </span>
        {activeTags.length > 0 && (
          <button className="tag-cloud-clear" onClick={onClear}>
            Zurücksetzen
          </button>
        )}
      </div>

      <div className="tag-cloud-chips">
        {visible.map(({ tag, count }) => (
          <button
            key={tag}
            className={`tag-chip ${activeTags.includes(tag) ? 'active' : ''}`}
            onClick={() => onToggle(tag)}
          >
            {tag}
            <span className="tag-chip-count">{count}</span>
          </button>
        ))}
        {hasMore && (
          <button
            className="tag-chip tag-chip-more"
            onClick={() => setExpanded(e => !e)}
          >
            {expanded ? 'Weniger anzeigen' : `+${tags.length - MAX_VISIBLE} weitere`}
          </button>
        )}
      </div>
    </div>
  );
}

export default TagCloud;
